import { AppDefinition } from '../../types/apps';

export const NOTES_EVENTS = {
  OPEN: 'NOTES_OPEN',
  CREATE: 'NOTES_CREATE',
  DELETE: 'NOTES_DELETE',
  EXPORT: 'NOTES_EXPORT',
} as const;

export const NotesMarkdownAppDefinition: AppDefinition = {
  appId: 'notes-markdown',
  name: 'Notes',
  version: '1.0.0',
  description: 'Beautiful collaborative markdown notes',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Note',
    phosphorWeight: 'duotone',
    color: '#f59e0b',
    metadata: {
      source: 'app',
      appId: 'notes-markdown',
      isAppIcon: true
    }
  },
  entityIcons: {
    'Note': {
      type: 'phosphor',
      phosphorIcon: 'Note',
      phosphorWeight: 'duotone',
      color: '#f59e0b' // Amber/gold - adds visual distinction for Note entities
    }
  },
  supportedFileTypes: ['.md', '.markdown'],
  events: NOTES_EVENTS,
  entityTypes: ['Note'],
  searchableSkeletonFields: {
    Note: ['markdownExport'], // first 800 chars enforced in compute_search_text
  },
  component: 'NotesMarkdownApp',
  requiresProps: false,
  requiresEntity: false,
  isCore: true,
  actions: {},
  // Superseded by NotesApp_v2 ('notes-v2') as the user-facing Notes app —
  // kept installed (isCore) since it still owns the shared 'Note' entity
  // create command, but no longer listed as its own app anywhere.
  hidden: true,
};


